import { RacemapColors } from '@racemap/utilities/consts/common';
import { useEffect, useRef } from 'react';

declare global {
  interface Window {
    calendar?: {
      schedulingButton: {
        load: (options: {
          url: string;
          color: string;
          label: string;
          target: HTMLElement | null;
        }) => void;
      };
    };
  }
}

const GoogleCalendarScheduleId =
  'AcZssZ0kwNhEg2XMt3xD1cQ7Wzfn5otN55BCZF3SJDtZVkkML0Bi4dBhRJLa_uKeGJaihMnZG5SPcMRI';

export default function PredictionWalkTroughGoogleCalenderRequest() {
  const containerRef = useRef(null);
  const initializedRef = useRef(false);

  useEffect(() => {
    if (initializedRef.current) return;
    initializedRef.current = true;

    const script = document.createElement('script');
    script.src = 'https://calendar.google.com/calendar/scheduling-button-script.js';
    script.async = true;

    script.onload = () => {
      window.calendar?.schedulingButton.load({
        url: `https://calendar.google.com/calendar/appointments/schedules/${GoogleCalendarScheduleId}?gv=true`,
        color: RacemapColors.PaleBlue,
        label: 'Book an Appointment',
        target: containerRef.current,
      });
    };

    document.body.appendChild(script);
  }, []);

  return (
    <>
      <link
        href="https://calendar.google.com/calendar/scheduling-button-script.css"
        rel="stylesheet"
      />
      <div ref={containerRef} />
    </>
  );
}
